import React from 'react'
import MuiLink from '@material-ui/core/Link'
import PhoneIcon from '@material-ui/icons/Phone'
import AddIcon from '@material-ui/icons/Add'

export function getSpeedDialCallBoralOption({
  boralTel,
  contactNumber,
  onClick,
}: {
  boralTel: string,
  contactNumber: string,
  onClick(): void,
}) {
  return {
    icon: (
      <MuiLink color='inherit' href={`tel:${boralTel}`}>
        <PhoneIcon />
      </MuiLink>
    ),
    // Workaround for this issue: https://github.com/mui-org/material-ui/issues/13522
    onClick,
    tooltip: {
      i18n: {
        data: { contactNumber },
        key: `OrderService.CallBoral`,
      },
    },
  }
}

export function getSpeedDialPlaceOrderOption({
  classes,
  onClick,
}: {
  classes: any,
  onClick(): void,
}) {
  return {
    icon: (
      <MuiLink color='inherit'>
        <AddIcon className={classes.icon} />
      </MuiLink>
    ),
    onClick,
    tooltip: {
      i18n: {
        data: {},
        key: `Place An Order`,
        englishValue: `Place An Order`,
      },
    },
  }
}
